import { render, staticRenderFns } from "./AddAsrResourceModal.vue?vue&type=template&id=027abbba&scoped=true"
import script from "./AddAsrResourceModal.vue?vue&type=script&lang=js"
export * from "./AddAsrResourceModal.vue?vue&type=script&lang=js"
import style0 from "./AddAsrResourceModal.vue?vue&type=style&index=0&id=027abbba&prod&lang=scss"
import style1 from "./AddAsrResourceModal.vue?vue&type=style&index=1&id=027abbba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027abbba",
  null
  
)

export default component.exports